import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const SessionsApi = createApi({
  reducerPath: 'SessionsApi',
  baseQuery,
  tagTypes: ['Sessions', 'SchoolDetail'],
  endpoints: builder => ({
    getSessions: builder.query({
      query: () => `/manage/sessions/`,
      providesTags: ['Sessions'],
    }),
    createSession: builder.mutation<any, any>({
      query: newSession => ({
        url: '/manage/sessions/',
        method: 'POST',
        body: newSession,
      }),
      invalidatesTags: ['Sessions', 'SchoolDetail'],
    }),
    updateSession: builder.mutation<any, { id: number; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/manage/sessions/${id}/`,
        method: 'PATCH',
        body: updates,
      }),
      async onQueryStarted({ id, updates }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          SessionsApi.util.updateQueryData(
            'getSessions',
            { search: '', levelId: '', gradeId: '' },
            draft => {
              const sessionYearsArray = draft;
              const sessionYearToUpdate = sessionYearsArray.find(
                (cls: any) => cls.id === id
              );
              if (sessionYearToUpdate) {
                Object.assign(sessionYearToUpdate, updates);
              }
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (_, __, { id }) => [
        { type: 'Sessions', id },
        'Sessions',
        'SchoolDetail',
      ],
    }),
    deleteSession: builder.mutation<void, number>({
      query: id => ({
        url: `/manage/sessions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [
        { type: 'Sessions', id },
        'Sessions',
        'SchoolDetail',
      ],
    }),
    getSchoolDetail: builder.query({
      query: () => `/school/detail`,
      providesTags: ['SchoolDetail'],
    }),
  }),
});

export const {
  useGetSessionsQuery,
  useCreateSessionMutation,
  useUpdateSessionMutation,
  useDeleteSessionMutation,
  useGetSchoolDetailQuery,
} = SessionsApi;
